import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    doc,
    getDoc,
    serverTimestamp,
    setDoc
  } from "firebase/firestore";
import { db } from "../../firebase";
import { toast } from 'react-toastify';
import { reset } from '../../features/auth/authSlice';
import Navbar1 from './Navbar1';
import config from '../../config';
import Sidebar from './Sidebar';
import Spinner from '../Spinner';

var url = config.nav.url;

var step0 = url+'step0';
var dashboard_link = url+'dashboard';

const gendersList = [
    {
      label: "Masculin",
      value: "Masculin",
    },
    {
      label: "Feminin",
      value: "Feminin",
    }
  ];

const diplomas = [
    {
      label: "Master (BAC + 5)",
      value: "Master (BAC + 5)",
    },
    {
      label: "Doctorat",
      value: "Doctorat",
    }
  ];

const genders1 = [
    {
      label: "Masculin",
      value: "Masculin",
    },
    {
      label: "Feminin",
      value: "Feminin",
    }
  ];

const titles1 = [
    {
      label: "M.",
      value: "M.",
    },
    {
      label: "Mme",
      value: "Mme",
    },
    {
      label: "Dr.",
      value: "Dr.",
    },
    {
      label: "Pr.",
      value: "Pr.",
    },
  ];

const grades1 = [
    {
      label: "AR",
      value: "AR",
    },
    {
      label: "CR",
      value: "CR",
    },
    {
      label: "MR",
      value: "MR",
    },
    {
      label: "DR",
      value: "DR",
    },
  ];

const genders2 = [
    {
      label: "Masculin",
      value: "Masculin",
    },
    {
      label: "Feminin",
      value: "Feminin",
    }
  ];

const titles2 = [
    {
      label: "M.",
      value: "M.",
    },
    {
      label: "Mme",
      value: "Mme",
    },
    {
      label: "Dr.",
      value: "Dr.",
    },
    {
      label: "Pr.",
      value: "Pr.",
    },
  ];

const grades2 = [
    {
      label: "AR",
      value: "AR",
    },
    {
      label: "CR",
      value: "CR",
    },
    {
      label: "MR",
      value: "MR",
    },
    {
      label: "DR",
      value: "DR",
    },
  ];

const genders3 = [
    {
      label: "Masculin",
      value: "Masculin",
    },
    {
      label: "Feminin",
      value: "Feminin",
    }
  ];

const titles3 = [
    {
      label: "M.",
      value: "M.",
    },
    {
      label: "Mme",
      value: "Mme",
    },
    {
      label: "Dr.",
      value: "Dr.",
    },
    {
      label: "Pr.",
      value: "Pr.",
    },
  ];

const grades3 = [
    {
      label: "AR",
      value: "AR",
    },
    {
      label: "CR",
      value: "CR",
    },
    {
      label: "MR",
      value: "MR",
    },
    {
      label: "DR",
      value: "DR",
    },
  ];

let id = '';
let theme1 = 'Développer et diffuser une nouvelle variété de sorgho';
let theme2 = 'Développer et diffuser une nouvelle variété de riz/blé';
let theme3 = 'Développer et diffuser une nouvelle variété de manioc';
let theme4 = 'Développer et diffuser une nouvelle variété de céréales maïs';
let theme5 = 'Développer et diffuser une nouvelle variété de patate douce';
let theme6 = 'Développer et diffuser une nouvelle variété de haricot commun';
let theme7 = 'Développer et diffuser les biofertilisants à base des amendements organiques';
let theme8 = 'Développer et diffuser les biopesticides à bases de plantes';
let theme9 = 'Développer et diffuser les biopesticides à base de microorganismes';
let theme10 = 'Développer et diffuser des aliments pour poisson d’élevage';
let theme11 = 'Mise au point d’un tamis automatique pour le tri des graines';

const Step1 = () => {
    const { t } = useTranslation();
    if(localStorage.getItem('id') != null){
        id = localStorage.getItem('id');
    }
    var today = Date();
    var lastDay = '01/30/2023';

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const type = localStorage.getItem("type");
    const [page, setUpdated] = useState({
        updated: false,
    });

    const [isLoading, setIsLoading] = useState(false);
    
    const [status, setEnabled] = useState({
        submitted: false,
    });

    const [deadline, setDeadline] = useState({
        isPassed: true,
        value: true
    });

    const handleGenderChange = (e) => {
        genders.gender = e.target.value;
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
        
        setGender({...genders, [genders]:e.target.value})
    }

    const handleDiplomaChange = (e) => {
        diploma.value = e.target.value;
        console.log(diploma.value);
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
        
        setDiploma({...diploma, [diploma]:e.target.value})
    }

    const handleTitle1Change = (e) => {
        title1.title = e.target.value;
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
        
        setTitle1({...title1, [title1]:e.target.value})
    }

    // Handle Input
    const handleGrade1Change = (e) => {
        grade1.grade = e.target.value;
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
        
        setGrade1({...grade1, [grade1]:e.target.value})
    }

    const handleGender1Change = (e) => {
        gender1.gender = e.target.value;
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
        
        setGender1({...gender1, [gender1]:e.target.value})
    }

    const handleTitle2Change = (e) => {
        title2.title = e.target.value;
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
        
        setTitle2({...title2, [title2]:e.target.value})
    }

    // Handle Input
    const handleGrade2Change = (e) => {
        grade2.grade = e.target.value;
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
        
        setGrade2({...grade2, [grade2]:e.target.value})
    }

    const handleGender2Change = (e) => {
        gender2.gender = e.target.value;
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
        
        setGender2({...gender2, [gender2]:e.target.value})
    }

    const handleTitle3Change = (e) => {
        title3.title = e.target.value;
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
        
        setTitle3({...title3, [title3]:e.target.value})
    }

    // Handle Input
    const handleGrade3Change = (e) => {
        grade3.grade = e.target.value;
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
        
        setGrade3({...grade3, [grade3]:e.target.value})
    }

    const handleGender3Change = (e) => {
        gender3.gender = e.target.value;
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
        
        setGender3({...gender3, [gender3]:e.target.value})
    }

    const [genders, setGender] = useState({
        gender: 'Masculin',
    });

    const [diploma, setDiploma] = useState({
        value: 'Master (BAC+5)',
    });

    const [title1, setTitle1] = useState({
        title: 'M.',
    });

    const [grade1, setGrade1] = useState({
        grade: 'AR',
    });

    const [gender1, setGender1] = useState({
        gender: 'Masculin',
    });

    const [title2, setTitle2] = useState({
        title: 'M.',
    });

    const [grade2, setGrade2] = useState({
        grade: 'AR',
    });

    const [gender2, setGender2] = useState({
        gender: 'Masculin',
    });

    const [title3, setTitle3] = useState({
        title: 'M.',
    });

    const [grade3, setGrade3] = useState({
        grade: 'AR',
    });

    const [gender3, setGender3] = useState({
        gender: 'Masculin',
    });

    let [firstRender, setFirstRender] = useState({
        firstRender: true,
    });

    const [theme, setTheme] = useState({
        value: '',
    });
    
    const handleThemeChange = (e) => {
        theme.value = e.target.value;
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
        setTheme({...theme, [theme]:e.target.value})
    }

    const [step, setStep] = useState({
        lastName: '',
        firstName: '',
        birthday: '',
        gender: '',
        specialty: '',
        structure: '',
        diploma: '',
        mbr1Name: '',
        mbr1Title: '',
        mbr1Grade: '',
        mbr1Specialty: '',
        mbr1Gender: '',
        mbr2Name: '',
        mbr2Title: '',
        mbr2Grade: '',
        mbr2Specialty: '',
        mbr2Gender: '',
        mbr3Name: '',
        mbr3Title: '',
        mbr3Grade: '',
        mbr3Specialty: '',
        mbr3Gender: '',
        theme: ''
    });

    const getStatus = async () => {
        try {
            const userRef = doc(db, "submissions", id);
            const userSnap = await getDoc(userRef);
            
            if(userSnap.exists()){
                status.submitted = true;
                setEnabled({...status, [status]:true})
            }
            
        } catch (error) {
            console.log(error);
        }
    };

    // get step details
    const getStepDetails = async () => {
        try {
            const stepRef = doc(db, "step1", id);
            const stepSnap = await getDoc(stepRef);
            
            if(stepSnap.exists()){
            return stepSnap.data();
            }
            else{
            return null;
            }
        } catch (error) {
            if(error.toString().includes("offline")){
                window.alert('Pas de connexion internet')
            }
            else{
                window.alert(error)
            }
        }
    };

    const { stp, isError, isSuccess, message} = useSelector(
        (state) => state.auth
      )

      useEffect(() => {
        // restrict access for examinators
        if(type === 'exam'){
            navigate('/admin')
        }
        
        // getting step details
        if(firstRender){
            deadline.isPassed = Date.parse(today) > Date.parse(lastDay);
            deadline.value = Math.round((Date.parse(lastDay) - Date.parse(today)) / (1000 * 60 * 60 * 24));
            setDeadline(deadline);

            getStatus();
            getStepDetails().then(data => {
                if(data != null){
                    setTheme({...theme, [theme]:data.theme})
                    setStep(data);
                    setFirstRender(false);
                }
            });
        }

        if (isError) {
        toast.error(message)
        }

        if (isSuccess || stp) {
            navigate("/step2")
        }
        dispatch(reset())
  }, [step, title1, grade1, title2, grade2, title3, grade3, isError, isSuccess, message, firstRender, dispatch])


    // Handle Input
    const handleInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;

        setStep({...step, [name]:value})
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
    }

    // Handle Submit
    const handleSubmit = async (event) => {
        event.preventDefault();
        if(page.updated){
            let them;
            if(theme.value?.length > 0){
                them = theme.value;
            }
            else{
                them = step.theme
            }
            if(window.confirm("Enregistrer les modifications ?")){
                setIsLoading(true);
                let {lastName, firstName, birthday, gender, specialty, structure, diplome, mbr1Name,
                    mbr1Title, mbr1Grade, mbr1Specialty, mbr1Gender, mbr2Name, mbr2Title, mbr2Grade,
                    mbr2Specialty, mbr2Gender, mbr3Name, mbr3Title, mbr3Grade, mbr3Specialty, mbr3Gender, theme} = step;
                diplome = diploma.value;
                mbr1Title = title1.title;
                mbr1Grade = grade1.grade;
                mbr2Title = title2.title;
                mbr2Grade = grade2.grade;
                mbr3Title = title3.title;
                mbr3Grade = grade3.grade;
                gender = genders.gender;
                mbr1Gender = gender1.gender;
                mbr2Gender = gender2.gender;
                mbr3Gender = gender3.gender;
                theme = them;
        
                const stepData = {
                    lastName,
                    firstName,
                    birthday,
                    gender,
                    specialty,
                    structure,
                    diplome,
                    mbr1Name,
                    mbr1Title,
                    mbr1Grade,
                    mbr1Specialty,
                    mbr1Gender,
                    mbr2Name,
                    mbr2Title,
                    mbr2Grade,
                    mbr2Specialty,
                    mbr2Gender,
                    mbr3Name,
                    mbr3Title,
                    mbr3Grade,
                    mbr3Specialty,
                    mbr3Gender,
                    theme
                  }
                  try {
                    await setDoc(doc(db, "step1", id), {
                      ...stepData,
                      timeStamp: serverTimestamp(),
                    });
                    navigate("/step2")
                  } catch (error) {
                    setIsLoading(false);
                    if(error.toString().includes("offline")){
                        window.alert('Pas de connexion internet')
                    }
                    else{
                        window.alert(error)
                    }
                  }
            }
        }
        else{
            navigate("/step2");
        }
    }

    const handleSave = async (event) => {
        event.preventDefault();
        if(page.updated){
            setIsLoading(true);
            let them;
            if(theme.value?.length > 0){
                them = theme.value;
            }
            else{
                them = step.theme
            }
            if(window.confirm("Enregistrer les modifications ?")){
                let {lastName, firstName, birthday, gender, specialty, structure, diplome, mbr1Name,
                    mbr1Title, mbr1Grade, mbr1Specialty, mbr1Gender, mbr2Name, mbr2Title, mbr2Grade,
                    mbr2Specialty, mbr2Gender, mbr3Name, mbr3Title, mbr3Grade, mbr3Specialty, mbr3Gender, theme} = step;
                diplome = diploma.value;
                mbr1Title = title1.title;
                mbr1Grade = grade1.grade;
                mbr2Title = title2.title;
                mbr2Grade = grade2.grade;
                mbr3Title = title3.title;
                mbr3Grade = grade3.grade;
                gender = genders.gender;
                mbr1Gender = gender1.gender;
                mbr2Gender = gender2.gender;
                mbr3Gender = gender3.gender;
                theme = them;
        
                const stepData = {
                    lastName,
                    firstName,
                    birthday,
                    gender,
                    specialty,
                    structure,
                    diplome,
                    mbr1Name,
                    mbr1Title,
                    mbr1Grade,
                    mbr1Specialty,
                    mbr1Gender,
                    mbr2Name,
                    mbr2Title,
                    mbr2Grade,
                    mbr2Specialty,
                    mbr2Gender,
                    mbr3Name,
                    mbr3Title,
                    mbr3Grade,
                    mbr3Specialty,
                    mbr3Gender,
                    theme
                  }
                  try {
                    await setDoc(doc(db, "step1", id), {
                      ...stepData,
                      timeStamp: serverTimestamp(),
                    });
                    navigate("/dashboard")
                  } catch (error) {
                    setIsLoading(false);
                    if(error.toString().includes("offline")){
                        window.alert('Pas de connexion internet')
                    }
                    else{
                        window.alert(error)
                    }
                  }
            }
        }
        else{
            navigate("/dashboard")
        }
    }
    if (isLoading) {
        return <Spinner />
      }

    return (
        <div>
            <Navbar1/>
            <div className="container m-5">
                <div className="row">
                <div className='col-md-3 m-4'>
                        <div className="row cadre">
                            <p className="mt-3 pt-0 text-white fw-bolder" id="dashb">{t('application')}</p>
                            <div className="m-3 mt-0 mb-0">
                                <Sidebar/>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8 pl-4">
                        <p className="lead fs-1">{t('menu_1')}</p>
                        <p><span className="star">*</span> = {t('required')}</p>
                        <form onSubmit={handleSubmit}>
                                <h2>{t('project_leader')}</h2>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span> {t('project_leader_name')}</label>
                                    <input type="text" required class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                    name="lastName" disabled={status.submitted || deadline.value <= 0} value ={step.lastName} onChange={handleInput}/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span> {t('project_leader_first_name')}</label>
                                    <input type="text" required class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                    name="firstName" disabled={status.submitted || deadline.value <= 0} value ={step.firstName} onChange={handleInput}/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span> {t('birth_day')}</label>
                                    <input type="date" required class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                    name="birthday" disabled={status.submitted || deadline.value <= 0} value ={step.birthday} onChange={handleInput}/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label me-4"><span className="star">*</span> {t('gender')}</label>
                                    <select value={genders.gender} disabled={status.submitted || deadline.value <= 0} onChange={handleGenderChange}>
                                            <option value={t('male')}>{t('male')}</option>
                                            <option value={t('female')}>{t('female')}</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span> {t('specialty')}</label>
                                    <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                    name="specialty" disabled={status.submitted || deadline.value <= 0} value ={step.specialty} onChange={handleInput}/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span> {t('assignment_structure')}</label>
                                    <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                    name="structure" disabled={status.submitted || deadline.value <= 0} value ={step.structure} onChange={handleInput}/>
                                </div>
                                <div className="mb-3 me-4">
                                    <label htmlFor="diplomaOpt" class="form-label me-4"><span className="star">*</span> {t('highest_diploma')}</label>
                                    <select value={diploma.value} disabled={status.submitted || deadline.value <= 0} onChange={handleDiplomaChange}>
                                        <option value='Master (Bac + 5)'>Master (Bac + 5)</option>
                                        <option value={t('PhD')}>{t('PhD')}</option>
                                    </select>
                                </div>
                                <h2>{t('project_team_presentation')}</h2>
                                <h4> - {t('member')} 1</h4>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span> {t('first_last_name')}</label>
                                    <input type="text" required disabled={status.submitted || deadline.value <= 0} class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                    name="mbr1Name" value ={step.mbr1Name} onChange={handleInput}/>
                                </div>
                                <div className="d-flex justify-content-start">
                                    <div className="mb-3 me-4">
                                        <label htmlFor="exampleInputEmail1" class="form-label me-4"><span className="star">*</span> {t('title')}</label>
                                        <select value={title1.title} disabled={status.submitted || deadline.value <= 0} onChange={handleTitle1Change}>
                                            <option value='M.' selected={'M.' === step.mbr1Title}>{t('M.')}</option>
                                            <option value='Ms.' selected={'Ms.' === step.mbr1Title}>{t('Ms.')}</option>
                                            <option value="Dr." selected={"Dr." === step.mbr1Title}>Dr.</option>
                                            <option value="Pr." selected={'Pr.' === step.mbr1Title}>Pr.</option>
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span> Grade</label>
                                        <select value={grade1.grade} disabled={status.submitted || deadline.value <= 0} onChange={handleGrade1Change}>
                                            {grades1.map((option) => (
                                            <option value={option.value}  selected={option.value === step.mbr1Grade}>{option.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span> {t('specialty')}</label>
                                    <input type="text" required class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                    name="mbr1Specialty" disabled={status.submitted || deadline.value <= 0} value ={step.mbr1Specialty} onChange={handleInput}/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label me-4"><span className="star">*</span> {t('gender')}</label>
                                    <select value={gender1.gender} disabled={status.submitted || deadline.value <= 0} onChange={handleGender1Change}>
                                            <option value={t('male')}>{t('male')}</option>
                                            <option value={t('female')}>{t('female')}</option>
                                    </select>
                                </div>
                                <h4> - {t('member')} 2</h4>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label">{t('first_last_name')}</label>
                                    <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                    name="mbr2Name" disabled={status.submitted || deadline.value <= 0} value ={step.mbr2Name} onChange={handleInput}/>
                                </div>
                                <div className="d-flex justify-content-start">
                                    <div className="mb-3 me-4">
                                        <label htmlFor="exampleInputEmail1" class="form-label me-4">{t('title')}</label>
                                        <select value={title2.title} disabled={status.submitted || deadline.value <= 0} onChange={handleTitle2Change}>
                                            <option value={t('M.')}>{t('M.')}</option>
                                            <option value={t('Ms.')}>{t('Ms.')}</option>
                                            <option value="Dr.">Dr.</option>
                                            <option value="Pr.">Pr.</option>
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="exampleInputEmail1" class="form-label">Grade</label>
                                        <select value={grade2.grade} disabled={status.submitted || deadline.value <= 0} onChange={handleGrade2Change}>
                                            {grades2.map((option) => (
                                            <option value={option.value}>{option.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label">{t('specialty')}</label>
                                    <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                    name="mbr2Specialty" disabled={status.submitted || deadline.value <= 0} value ={step.mbr2Specialty} onChange={handleInput}/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label me-4">{t('gender')}</label>
                                    <select value={gender2.gender} disabled={status.submitted || deadline.value <= 0} onChange={handleGender2Change}>
                                            <option value={t('male')}>{t('male')}</option>
                                            <option value={t('female')}>{t('female')}</option>
                                    </select>
                                </div>
                                <h4> - {t('member')} 3</h4>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label">{t('first_last_name')}</label>
                                    <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                    name="mbr3Name" disabled={status.submitted || deadline.value <= 0} value ={step.mbr3Name} onChange={handleInput}/>
                                </div>
                                <div className="d-flex justify-content-start">
                                    <div className="mb-3 me-4">
                                        <label htmlFor="exampleInputEmail1" class="form-label me-4">{t('title')}</label>
                                        <select value={title3.title} disabled={status.submitted || deadline.value <= 0} onChange={handleTitle3Change}>
                                            <option value={t('M.')}>{t('M.')}</option>
                                            <option value={t('Ms.')}>{t('Ms.')}</option>
                                            <option value="Dr.">Dr.</option>
                                            <option value="Pr.">Pr.</option>
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="exampleInputEmail1" class="form-label">Grade</label>
                                        <select value={grade3.grade} disabled={status.submitted || deadline.value <= 0} onChange={handleGrade3Change}>
                                            {grades3.map((option) => (
                                            <option value={option.value}>{option.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label">{t('specialty')}</label>
                                    <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                    name="mbr3Specialty" disabled={status.submitted || deadline.value <= 0} value ={step.mbr3Specialty} onChange={handleInput}/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label me-4">{t('gender')}</label>
                                    <select value={gender3.gender} disabled={status.submitted || deadline.value <= 0} onChange={handleGender3Change}>
                                            <option value={t('male')}>{t('male')}</option>
                                            <option value={t('female')}>{t('female')}</option>
                                    </select>
                                </div>
                                <h3><span className="star">*</span>{t('themes')}</h3>
                                <div onChange={handleThemeChange}>
                                    <div className="mb-3">
                                        <label for="vehicle1" className='mb-3 ms-2'><strong>{t('theme')} N° 1 - {t('theme_n1')}</strong></label><br></br>
                                        <p><input type="radio" disabled={status.submitted || deadline.value <= 0} value={theme1} name="theme" checked={theme.value?.includes(theme1)} /> {t('theme1')}</p>
                                        <p><input type="radio" disabled={status.submitted || deadline.value <= 0} value={theme2} name="theme" checked={theme.value?.includes(theme2)}/> {t('theme2')}</p>
                                        <p><input type="radio" disabled={status.submitted || deadline.value <= 0} value={theme3} name="theme" checked={theme.value?.includes(theme3)} /> {t('theme3')}</p>
                                        <p><input type="radio" disabled={status.submitted || deadline.value <= 0} value={theme4} name="theme" checked={theme.value?.includes(theme4)} /> {t('theme4')}</p>
                                        <p><input type="radio" disabled={status.submitted || deadline.value <= 0} value={theme5} name="theme" checked={theme.value?.includes(theme5)} /> {t('theme5')}</p>
                                        <p><input type="radio" disabled={status.submitted || deadline.value <= 0} value={theme6} name="theme" checked={theme.value?.includes(theme6)} /> {t('theme6')}</p>
                                    </div>
                                    <div className="mb-3">
                                        <label for="vehicle1" className='mb-3 ms-2'><strong>{t('theme')} N° 2 - {t('theme_n2')}</strong></label><br></br>
                                        <p><input type="radio" disabled={status.submitted || deadline.value <= 0} value={theme7} name="theme" checked={theme.value?.includes(theme7)} /> {t('theme7')}</p>
                                        <p><input type="radio" disabled={status.submitted || deadline.value <= 0} value={theme8} name="theme" checked={theme.value?.includes(theme8)}/> {t('theme8')}</p>
                                    </div>
                                    <div className="mb-3">
                                        <label for="vehicle1" className='mb-3 ms-2'><strong>{t('theme')} N° 3 - {t('theme_n3')}</strong></label><br></br>
                                        <p><input type="radio" disabled={status.submitted || deadline.value <= 0} value={theme9} name="theme" checked={theme.value?.includes(theme9)} /> {t('theme9')}</p>
                                    </div>
                                    <div className="mb-3">
                                        <label for="vehicle1" className='mb-3 ms-2'><strong>{t('theme')} N° 5 - {t('theme_n4')}</strong></label><br></br>
                                        <p><input type="radio" disabled={status.submitted || deadline.value <= 0} value={theme10} name="theme" checked={theme.value?.includes(theme10)} /> {t('theme10')}</p>
                                    </div>
                                    <div className="mb-3">
                                        <label for="vehicle1" className='mb-3 ms-2'><strong>{t('theme')} N° 6 - {t('theme_n5')}</strong></label><br></br>
                                        <p><input type="radio" disabled={status.submitted || deadline.value <= 0} value={theme11} name="theme" checked={theme.value?.includes(theme11)} /> {t('theme11')}</p>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <div className="col-md-8">
                                        <input type="submit" disabled={status.submitted || deadline.value <= 0} className='col-md-3 btn btn-primary'  id="vehicle1" name="vehicle1" value={t('previous')} onClick={()=>{navigate("/step0")}}/>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="d-flex justify-content-end">
                                            <div className="col-md-8">
                                                <input type="submit" disabled={status.submitted || deadline.value <= 0} className='col-md-8 btn btn-primary'  id="vehicle1" name="vehicle1" value={t('save')} onClick={handleSave}/>
                                            </div>
                                            <div className="col-md-4">
                                                <input type="submit" disabled={status.submitted || deadline.value <= 0} className='btn btn-outline-primary'  id="vehicle1" name="vehicle1" value={t('continue')} onClick={handleSubmit}/>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="space"/>
            </div>
        </div>
    )
}

export default Step1;
